

import React, { useEffect, useState } from 'react';
import OrderSearchForm from '../components/OrderSearchForm'
import HeaderOrder from '../components/HeaderOrder'
import HeaderWelcome from '../components/HeaderWelcome'
import MaintenancePage from './MaintenancePage';

const Loading = () => (
  <div className='loader-container'>
    <div className='spinner'></div>
  </div>
)

function getNowInEST() {
  // Get current time in EST (America/New_York)
  const now = new Date();
  // Format as 'YYYY-MM-DDTHH:mm:ss' in EST
  const estString = now.toLocaleString('en-US', { timeZone: 'America/New_York', hour12: false });
  // Convert back to Date object in EST
  return new Date(estString);
}

function isNowBetweenEST(start, end) {
  if (!start || !end) return false;
  const now = getNowInEST();
  const startDate = new Date(start.replace(' ', 'T'));
  const endDate = new Date(end.replace(' ', 'T'));
  return now >= startDate && now <= endDate;
}

export default function OrderSarchPage(props) {
  const [maintenance, setMaintenance] = useState(null);

  useEffect(() => {
    fetch('/maintenanceConfig.json')
      .then((res) => res.json())
      .then((data) => setMaintenance(data))
      .catch(() => setMaintenance({ isMaintenance: false }));
  }, []);

  if (maintenance === null) return <Loading />;
  if (
    maintenance.isMaintenance &&
    isNowBetweenEST(maintenance.startDate, maintenance.endDate)
  ) {
    return <MaintenancePage />;
  }

  let isSearch = false
  let pageType = props.pageType

  if (props.pageType === 'search') {
    isSearch = true
  }

  return isSearch ? (
    <>
      {/* <HeaderOrder /> */}
      <OrderSearchForm />
    </>
  ) : (
    <>
      <HeaderWelcome />
      <OrderSearchForm />
    </>
  )
}
